import { createContext } from 'react';

import type { FooterContent } from '../models/FooterContent';

export interface FooterContext extends FooterContent {
  isMobileOffice: boolean;
}

export const defaultFooterContext: FooterContext = {
  isMobileOffice: false,
  languages: [],
  paymentMethodsItems: [],
  copyrightLinks: [],
  siteLinksColumns: [],
  socialMediaLinks: [],
};
export const footerContext = createContext<FooterContext>(defaultFooterContext);

export const FooterProvider = footerContext.Provider;
